import { render, staticRenderFns } from "./course-image.vue?vue&type=template&id=935ecd7a&"
import script from "./course-image.vue?vue&type=script&lang=js&"
export * from "./course-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports